<!-- If you change the layout or heights of any group/product related html -->
<!-- Go into the inventory-view-model-scroll-helper.ts/inventory-constants.ts and update the item heights -->

<!-- Inventory w/ no items on creation -->
<ion-row
  [class.hide]="inventory?.numProducts !== 0"
  data-cy="inventory-worksheet-empty-state-row"
>
  <ion-col data-cy="inventory-worksheet-empty-state-text-column" size="12">
    <div
      data-cy="inventory-worksheet-empty-state-text-section"
      class="inventory-worksheet-empty-state-text"
    >
      <span data-cy="inventory-worksheet-empty-state-text">
        {{ 'i18n.inventory.emptyStateTextForInventory' | translate }}
      </span>
    </div>
  </ion-col>
  <!-- Add Products Button -->
  <ion-col data-cy="inventory-worksheet-add-products-button-column" size="12">
    <div
      data-cy="inventory-worksheet-add-products-button-section"
      class="inventory-worksheet-add-products-button"
    >
      <ion-button
        data-cy="inventory-worksheet-add-products-button"
        class="usf-fill-green-button"
        (click)="openAddProductsPopover($event)"
        [disabled]="!isOnline"
        [class.offline]="!isOnline"
      >
        {{ 'i18n.common.addProducts' | translate }}
      </ion-button>
    </div>
  </ion-col>
</ion-row>

<!-- Inventory w/ at least 1 item on creation -->
<ion-row
  *cdkVirtualFor="
    let item of inventory?.items;
    let i = index;
    trackBy: trackItem
  "
  [attr.data-cy]="'inventory-worksheet-group-sort-product-row-' + i"
  class="inventory-worksheet-group-sort-product-row"
>
  <!-- Group Names -->
  <ion-col
    [attr.data-cy]="'inventory-worksheet-group-header-section-' + i"
    [class.hide]="
      item?.itemType !== ItemTypes.group || inventory?.numProducts === 0
    "
    size="12"
  >
    <h2
      [attr.data-cy]="'inventory-worksheet-group-header-text-' + i"
      [ngClass]="
        item?.hasProducts
          ? 'inventory-worksheet-group-header'
          : 'inventory-worksheet-no-products-header'
      "
    >
      {{ item?.groupName }}&nbsp;({{ item?.numProducts || 0 }}&nbsp;{{
        (item?.numProducts > 1 || !item?.numProducts
          ? 'i18n.lists.products'
          : 'i18n.lists.product'
        ) | translate
      }})
    </h2>
  </ion-col>
  <!-- Sort Headers (group w/ products) -->
  <ion-col
    [attr.data-cy]="'inventory-worksheet-sort-header-section-' + i"
    [class.hide]="item?.itemType !== ItemTypes.sort"
    [attr.size]=""
    size="{{ item?.sortHeaderColumnSize }}"
    offset="{{ item?.sortHeaderOffsetSize }}"
  >
    <ion-row class="inventory-worksheet-sort-header">
      <ng-container *ngFor="let sortHeader of item?.headers">
        <ion-col
          *ngIf="sortHeader?.displayText"
          [attr.data-cy]="
            'inventory-worksheet-sort-header-' +
            sortHeader?.headerName?.toLowerCase() +
            '-column'
          "
          size="{{ sortHeader?.size }}"
          offset="{{ sortHeader?.offset }} "
        >
          <div
            [attr.data-cy]="
              'inventory-worksheet-sort-header-' +
              sortHeader?.headerName?.toLowerCase() +
              '-section'
            "
            class="sortable-section-header-option"
            [class.sort-active]="
              item?.selectedHeader === sortHeader?.headerName
            "
            (click)="handleSortEvent(item?.groupName, sortHeader)"
          >
            <p
              [attr.data-cy]="
                'inventory-worksheet-sort-header-' +
                sortHeader?.headerName?.toLowerCase() +
                '-label'
              "
            >
              {{ sortHeader?.displayText | translate }}
            </p>
            <div
              *ngIf="
                platform === PlatformEnum.desktop &&
                sortHeader?.headerName !== 'groupName'
              "
              [attr.data-cy]="
                'inventory-worksheet-sort-header-' +
                sortHeader?.headerName?.toLowerCase() +
                '-caret-section'
              "
              class="caret-icon"
            >
              <ion-icon
                *ngIf="
                  item?.selectedHeader !== sortHeader?.headerName ||
                  (item?.selectedHeader === sortHeader?.headerName &&
                    sortHeader?.sortDirection === 'asc')
                "
                [attr.data-cy]="
                  'inventory-worksheet-sort-header-' +
                  sortHeader?.headerName?.toLowerCase() +
                  '-caret-up-icon'
                "
                name="caret-up-outline"
              ></ion-icon>
              <ion-icon
                *ngIf="
                  item?.selectedHeader !== sortHeader?.headerName ||
                  (item?.selectedHeader === sortHeader?.headerName &&
                    sortHeader?.sortDirection === 'desc')
                "
                [attr.data-cy]="
                  'inventory-worksheet-sort-header-' +
                  sortHeader?.headerName?.toLowerCase() +
                  '-down-icon'
                "
                name="caret-down-outline"
              ></ion-icon>
            </div>
          </div>
        </ion-col>
      </ng-container>
    </ion-row>
  </ion-col>
  <!-- Simple Label Headers -->
  <ion-col
    [attr.data-cy]="'inventory-worksheet-label-header-section-' + i"
    [class.hide]="item?.itemType !== ItemTypes.justALabel"
    size="11.35"
    offset="0.65"
  >
    <ion-row class="inventory-worksheet-label-header">
      <ion-col size="0.5" offset="0.3">
        <p>{{ 'i18n.inventory.groupLabels.lineLabel' | translate }}</p>
      </ion-col>
      <ion-col size="2.5" offset="0.35">
        <p>{{ 'i18n.inventory.groupLabels.productLabel' | translate }}</p>
      </ion-col>
      <ion-col size="1.5" offset="1.2">
        <p>{{ 'i18n.inventory.groupLabels.unitLabel' | translate }}</p>
      </ion-col>
      <ion-col size="1.5" offset="0.35">
        <p>{{ 'i18n.inventory.groupLabels.uomLabel' | translate }}</p>
      </ion-col>
      <ion-col size="0.75" offset="0.35">
        <p>{{ 'i18n.inventory.groupLabels.priceLabel' | translate }}</p>
      </ion-col>
      <ion-col size="1" offset="0.85">
        <p>{{ 'i18n.inventory.groupLabels.unitPriceLabel' | translate }}</p>
      </ion-col>
    </ion-row>
  </ion-col>
  <!-- No Products in Group -->
  <ion-col
    [attr.data-cy]="'inventory-no-products-section-' + i"
    [class.hide]="
      !(item?.itemType === ItemTypes.group && !item?.hasProducts) ||
      (item?.itemType === ItemTypes.group &&
        inventory?.inventoryOptions?.selectedGroup?.groupName === 'All' &&
        inventory?.inventoryOptions?.searchKey) ||
      inventory?.numProducts === 0
    "
    size="12"
  >
    <div
      [attr.data-cy]="'inventory-no-products-container-' + i"
      class="inventory-worksheet-no-products"
    >
      <span [attr.data-cy]="'inventory-no-producs-card-text-' + i">
        {{ 'i18n.inventory.noProductsInGroup' | translate }}
      </span>
    </div>
  </ion-col>
  <!-- Products -->
  <ion-col
    [attr.data-cy]="'inventory-product-section-' + i"
    [class.hide]="item?.itemType !== ItemTypes.product"
    size="12"
  >
    <app-inventory-count-card
      *ngIf="
        inventory?.inventoryOptions?.inventoryWorksheetMode ===
        InventoryWorksheetMode.count
      "
      [platform]="platform"
      [inventoryId]="inventory?.inventoryId"
      [inventoryItem]="item"
      [index]="i"
      [isOnline]="isOnline"
      (productDescriptionClick)="handleProductDescriptionClick($event)"
      (updateQuantityEvent)="handleQuantityEvent($event)"
      (toolTipHoverEvent)="handleToolTipHover($event)"
      (toolTipLeaveEvent)="handleTooltipLeave()"
      (itemForInformationEvent)="handleInfoIconClick($event)"
    ></app-inventory-count-card>
    <app-inventory-edit-card
      *ngIf="
        inventory?.inventoryOptions?.inventoryWorksheetMode ===
        InventoryWorksheetMode.edit
      "
      [platform]="platform"
      [inventoryId]="inventory?.inventoryId"
      [inventoryItem]="item"
      [groupHeaders]="inventory?.groupHeaders"
      [index]="i"
      (productDescriptionClick)="handleProductDescriptionClick($event)"
      (selectionEvent)="handleSelectionEvent($event)"
      (updateGroupEvent)="handleGroupEvent($event)"
      (updateUOMEvent)="handleUOMEvent($event)"
      (updateConversionFactorEvent)="handleConversionFactorEvent($event)"
      (updatePriceOverrideEvent)="handlePriceOverridEvent($event)"
      (toolTipHoverEvent)="handleToolTipHover($event)"
      (toolTipLeaveEvent)="handleTooltipLeave()"
      (resetPreviousHotkeyIdEvent)="resetPreviousHotkeyId()"
      (itemForInformationEvent)="handleInfoIconClick($event)"
      (lineNumberEvent)="handleLineNumberChange($event)"
    ></app-inventory-edit-card>
  </ion-col>
</ion-row>

<!-- No Search Results -->
<ion-row
  [class.hide]="
    !(inventory?.items?.length === 0 && inventory?.numProducts !== 0)
  "
  data-cy="inventory-worksheet-no-search-results-row"
  class="inventory-worksheet-group-sort-product-row"
>
  <ion-col data-cy="inventory-worksheet-no-search-results-section" size="12">
    <div
      data-cy="inventory-worksheet-no-search-results-container"
      class="inventory-worksheet-no-search-results"
    >
      <span data-cy="inventory-worksheet-no-search-results-text">
        {{ 'i18n.search.noSearchResults.noResultFound' | translate }}
      </span>
      <span data-cy="inventory-worksheet-no-search-results-subtext">
        {{ 'i18n.search.noSearchResults.pleaseTryAgain' | translate }}
      </span>
    </div>
  </ion-col>
</ion-row>
